import { render, staticRenderFns } from "./scheduleTransfer.vue?vue&type=template&id=640b3f46&scoped=true&"
import script from "./scheduleTransfer.vue?vue&type=script&lang=js&"
export * from "./scheduleTransfer.vue?vue&type=script&lang=js&"
import style0 from "./scheduleTransfer.vue?vue&type=style&index=0&id=640b3f46&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640b3f46",
  null
  
)

export default component.exports